export enum OrderReviewPricingTestButtonEnum {
  SUBMIT_BTN = 'submit-btn',
}
